import { render, staticRenderFns } from "./el-tree-select.vue?vue&type=template&id=2b1865e0&scoped=true&"
import script from "./el-tree-select.vue?vue&type=script&lang=js&"
export * from "./el-tree-select.vue?vue&type=script&lang=js&"
import style0 from "./el-tree-select.vue?vue&type=style&index=0&id=2b1865e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1865e0",
  null
  
)

export default component.exports